import { ArrowBackIosOutlined, ArrowForwardIosRounded } from '@mui/icons-material';
import { Box, Button, Divider, TextField, Typography } from '@mui/material';
import { FC, useState } from 'react';
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { toast } from 'sonner';
import { useAgencyStore } from 'Application/store';

interface AgencyCustomizationProps {
    goBack: () => void;
    proceedToNextStep: () => void;
}

const validationSchema = Yup.object().shape({
    agencyUrl: Yup.string().required('Sub-domain is required'),
});

export const AgencyCustomization: FC<AgencyCustomizationProps> = ({ proceedToNextStep, goBack }) => {
    const { createAgencyData, setAgencyCustomizationStep } = useAgencyStore();
    const initialValues = {
        agencyUrl: createAgencyData.agency.agencyUrl || '',
    };
    const [image, setImage] = useState<File | null>(null);

    const handleImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const imageFile = e.target.files?.[0] || null;
        setImage(imageFile);
    };

    const handleSubmit = async (values: typeof initialValues) => {
        try {
            setAgencyCustomizationStep({ agencyUrl: values.agencyUrl, logo: image }); // Save logo and URL
            proceedToNextStep();
        } catch (error) {
            toast.error(`There is an error: ${error}`);
            console.log(error);
        }
    };

    return (
        <Box>
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ touched, errors }) => (
                    <Form>
                        <Typography className="mb-2 text-[13px]">Sub-domain</Typography>
                        <Field
                            as={TextField}
                            id="agencyUrl"
                            name="agencyUrl"
                            variant="outlined"
                            fullWidth
                            error={touched.agencyUrl && Boolean(errors.agencyUrl)}
                            helperText={touched.agencyUrl && errors.agencyUrl}
                            className="mb-4 text-[12px] font-light"
                        />
                        <Typography>Agency Logo</Typography>
                        <Typography variant="body1" gutterBottom>
                            <input
                                type="file"
                                id="fileInput"
                                name="fileInput"
                                onChange={handleImage}
                                accept="image/*"
                                className="mt-1 p-2 w-full border rounded-md"
                            />
                            {image && (
                                <div className="mt-2 w-3/12 h-3/12 rounded-full overflow-hidden">
                                    <img src={URL.createObjectURL(image)} alt="Logo Preview" className="w-full h-full object-cover" />
                                </div>
                            )}
                        </Typography>
                        <Divider className="mt-4 mb-6" />
                        <Box className="flex justify-between items-center">
                            <Button onClick={goBack} startIcon={<ArrowBackIosOutlined />} variant="outlined">
                                Back
                            </Button>
                            <Button disableElevation type="submit" variant="contained" endIcon={<ArrowForwardIosRounded />}>
                                Next
                            </Button>
                        </Box>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};
